import { render, staticRenderFns } from "./evaluationProject.vue?vue&type=template&id=db607a2e&scoped=true&"
import script from "./evaluationProject.vue?vue&type=script&lang=js&"
export * from "./evaluationProject.vue?vue&type=script&lang=js&"
import style0 from "./evaluationProject.vue?vue&type=style&index=0&id=db607a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db607a2e",
  null
  
)

export default component.exports